<template>
  <div class="container education">
    <div class="section">
      <div class="title-col">
        <h3>Education</h3>
        <hr>
      </div>
      <div class="content-col">
        <ul>
          <li>
            <em>Graduated 2008</em>
            <strong>Art Institute of Fort Lauderdale</strong>  
            <span>Bachelor's of Computer Science - Interactive Media</span>
          </li>
          <li>
            <em>Graduated 2004</em>
            <strong>Art Institute of Pittsburgh</strong>
            <span>Associate's of Computer Science - Interactive Media</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Education'
}
</script>
